import { Component, inject, signal } from '@angular/core';
import { MyExportsGridComponent } from './my-exports-grid/my-exports-grid.component';
import { UploadDateComponent } from '../../field-components/upload-date/upload-date.component';
import { ExportTypesSelectComponent } from '../../field-components/export-types-select/export-types-select.component';
import { FileDataStore } from '../../../store/file-data.store';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { ExportType } from '../../../models/export-type';

@Component({
  selector: 'app-my-exports',
  imports: [
    MyExportsGridComponent,
    UploadDateComponent,
    ExportTypesSelectComponent,
    MatButtonModule,
  ],
  templateUrl: './my-exports.component.html',
  styleUrl: './my-exports.component.scss',
})
export class MyExportsComponent {
  readonly store = inject(FileDataStore);
  readonly mode = 'myExports';
  form: FormGroup;
  createDateReady = signal<boolean>(false);
  exportTypesReady = signal<boolean>(false);
  initialLoadComplete = signal<boolean>(false);

  constructor(
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({});
  }

  handleCreateDateValueChange(date: Date | null) {
    this.store.setThresholdDate(date, this.mode);
  }

  handleCreateDateReady() {
    this.createDateReady.set(true);
    this.tryInitialLoad();
  }

  handleExportTypesReady() {
    this.exportTypesReady.set(true);
    this.tryInitialLoad();
  }

  handleExportTypesValueChange(types: ExportType[] | null) {
    this.store.setExportTypes(types);
  }

  private tryInitialLoad() {
    if (!this.createDateReady() || !this.exportTypesReady() || this.initialLoadComplete()) {
      return;
    }

    setTimeout(() => {
      this.onGenerateGrid();
    }, 300);
    this.initialLoadComplete.set(true);
  }

  onGenerateGrid() {
    this.store.getMyExports();
  }
}
